var map = {
	"./qld/lgas": 542,
	"./wa/lgas": 548
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 507;


//////////////////
// WEBPACK FOOTER
// ../data ^\.\/.*\/lgas$
// module id = 507
// module chunks = 0